export default "__VITE_ASSET__DFhKACN9__"